module.exports = __webpack_public_path__ + "static/img/z03.81faf331.png";